import { IconComponentProps } from '@typings';
import cx from 'classnames';
import React from 'react';

const variants = {
  dark: '#333333',
  light: '#ffffff',
  red: '#D41D11',
};

export type SpinnerVariantColor = keyof typeof variants;

interface Props extends IconComponentProps {
  variant?: SpinnerVariantColor;
}

export const Spinner = ({ variant = 'dark', className, ...props }: Props) => {
  const idPathOne = React.useId();
  const idPathTwo = React.useId();

  return (
    <svg width="1rem" height="1rem" viewBox="0 0 20 20" fill="none" className={cx('animate-spin', className)} {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M10 4.72a5.28 5.28 0 0 0 0 10.56V17a7 7 0 1 1 0-14z" fill={`url(#${idPathOne})`} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.73 6.27A5.3 5.3 0 0 0 10 4.72V3a7 7 0 1 1 0 14v-1.72a5.28 5.28 0 0 0 3.73-9.01"
        fill={`url(#${idPathTwo})`}
      />
      <defs>
        <linearGradient id={idPathOne} x1="-.68" y1="12.95" x2="6.34" y2="-1.27" gradientUnits="userSpaceOnUse">
          <stop offset=".2" stopColor={variants[variant]} stopOpacity="0" />
          <stop offset="1" stopColor={variants[variant]} stopOpacity=".51" />
        </linearGradient>
        <linearGradient id={idPathTwo} x1="14.42" y1="17.37" x2="10" y2="-.81" gradientUnits="userSpaceOnUse">
          <stop stopColor={variants[variant]} />
          <stop offset=".65" stopColor={variants[variant]} stopOpacity=".39" />
        </linearGradient>
      </defs>
    </svg>
  );
};
